import AlertsMap from "./alertsMap";

export default AlertsMap;
